<template>
    <div id="no-vip-popover" :class="{ 'big-width': lang !== 'zh' }">
        <div class="top-bar">
            <img :src="require(`@/app/assets/img/vip-tip/no-vip-top${lang !== 'zh' ? 2 : ''}.png`)" alt="" />
            <div class="content">
                <div class="content-title">{{ $t("edrawmaxVip") }}</div>
                <div class="content-desc">{{ $t("vipDesc") }}</div>
            </div>
        </div>
        <div class="benefit-list">
            <div class="benefit-item" v-for="item in 4" :key="item">
                <img :src="require(`@/app/assets/img/vip-tip/no-vip-benefit${item}.svg`)" alt="" />
                <span>{{ $t(`benefitText${item}`) }}</span>
            </div>
        </div>
        <div class="btn-bar" :class="{ 'has-bubble': !!purchaseBubble }">
            <div class="vip-btn" @click="toVip">
                <div class="top-tip" v-if="!!purchaseBubble">{{ purchaseBubble }}</div>
                <span>{{ $t("vip") }}</span>
            </div>
            <div class="show-more" @click="showMore" v-if="internal && lang == 'zh'">{{ $t("showMore") }}</div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";
    import publicStore from "@/public/store/publicStore";

    @Component({
        components: {
            // Dialog,
        },
    })
    export default class NoVipPopover extends Vue {
        get purchaseBubble() {
            return this.$store.state.publicStore.purchaseBubble || publicStore.state.purchaseBubble;
        }

        toVip() {
            if (this.internal && !this.$validateLogin()) return;
            this.$openBuyPage("hoverNowFloatWindow");
            this.sensors.track("clickButtonInBuyNowFloatWindow", {
                Catalogues: "payPath",
                button_name: "buyNow",
            });
        }
        showMore() {
            if (this.internal && !this.$validateLogin()) return;
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "noVipBuyNowFloatWindow",
            });
            this.$store.commit("toPublicStatus", {
                type: "upgradeSuffix",
                data: "action=compare",
            });
            this.$store.commit("toPublicStatus", {
                type: "showBuyframe",
                data: true,
            });
            this.sensors.track("clickButtonInBuyNowFloatWindow", {
                Catalogues: "payPath",
                button_name: "learnMore",
            });
        }

        mounted() {}

        created() {}
    }
</script>

<style lang="stylus" scoped>
    #no-vip-popover
      width 224px
      background var(--bg-color-tertiary)
      box-shadow: $modal-shadow;
      border-radius 8px
      overflow hidden
      &.big-width
        width 360px

      .top-bar
        position relative
        height 80px
        padding 18px
        img
          display block
          width 100%
          height 80px
          position absolute
          left 0
          top 0
          // z-index -1
        .content
          position relative
          z-index 10
          color #632400
          .content-title
            font-size 16px
            font-weight 700
            line-height 20px
            margin-bottom 8px
          .content-desc
            font-size 12px
      .benefit-list
            margin 24px
            .benefit-item
                  display flex

                  align-items center
                  color var(--text-color-primary)
                  font-size 14px
                  line-height 18px
                  margin-bottom 16px
                  &:last-child
                        margin-bottom 0
                  img
                        display block
                        margin-right 8px
      .btn-bar
            margin 24px
            &.has-bubble
              margin-top 34px
            .vip-btn
                  width 100%
                  height 32px;
                  background linear-gradient(to right, #FFEF92, #FFD67B)
                  border-radius 6px
                  cursor pointer
                  font-size 12px
                  padding 8px 0
                  color #402300
                  text-align center
                  position relative
                  &:hover
                        background  #FFD67B
                  .top-tip
                    position absolute
                    bottom 26px
                    left 0
                    background linear-gradient(to left, #FF4848, #FF9C55)
                    border-radius  8px 8px 8px 0px
                    padding 4px 6px
                    color #fff
                    font-size 10px
                    height 20px


            .show-more
                  width 100%
                  text-align center
                  margin-top 16px
                  color rgba(0,0,0,0.5)
                  cursor pointer
                  &:hover
                        color #000
</style>

<i18n>
{
  "zh": {
    "benefitText1": "绘图符号无限用",
    "benefitText2": "精品模板无限用",
    "benefitText3": "文件无水印导出",
    "benefitText4": "10G超大云空间",
    "vip": "开通VIP",
    "showMore": "了解更多",
    "edrawmaxVip": "亿图图示会员",
    "vipDesc": "尊享30+特权"
  },
  "en": {
    "benefitText1": "Unlimited use of drawing symbols",
    "benefitText2": "Unlimited use of boutique templates",
    "benefitText3": "Export files with no watermarks",
    "benefitText4": "10GB cloud storage",
    "vip": "Buy Now",
    "showMore": "Learn More",
    "edrawmaxVip": "EdrawMax Pro",
    "vipDesc": "Enjoy 30+ benefits"
  },
  "fr": {
    "benefitText1": "Utilisation illimitée des symboles de dessin",
    "benefitText2": "Utilisation illimitée des modèles fournis",
    "benefitText3": "Export de fichiers sans filigrane",
    "benefitText4": "10 Go de stockage dans le cloud",
    "vip": "Acheter maintenant",
    "showMore": "En savoir plus",
    "edrawmaxVip": "EdrawMax Pro",
    "vipDesc": "Obtenez plus de 30 avantages"
  },
  "de": {
    "benefitText1": "Unbegrenzte Verwendung von gezeichneten Symbolen",
    "benefitText2": "Unbegrenzte Verwendung von Boutique-Vorlagen",
    "benefitText3": "Export von Dateien ohne Wasserzeichen",
    "benefitText4": "10 GB Cloud-Speicher",
    "vip": "Jetzt kaufen",
    "showMore": "Weitere Informationen",
    "edrawmaxVip": "EdrawMax Pro",
    "vipDesc": "Profitieren Sie von über 30 Vorteilen"
  },
  "jp": {
    "benefitText1": "図面記号の使用無制限",
    "benefitText2": "質の高いテンプレートの使用無制限",
    "benefitText3": "透かしなしのファイルエクスポート",
    "benefitText4": "10GBのクラウドストレージ",
    "vip": "今すぐ購入",
    "showMore": "詳細を表示",
    "edrawmaxVip": "EdrawMax Pro",
    "vipDesc": "30種類以上の特典をご活用ください"
  },
  "es": {
    "benefitText1": "Uso ilimitado de símbolos de dibujo",
    "benefitText2": "Uso ilimitado de plantillas predefinidas",
    "benefitText3": "Exportación de archivos sin marcas de agua",
    "benefitText4": "10 GB de almacenamiento en la nube",
    "vip": "Comprar ahora",
    "showMore": "Más información",
    "edrawmaxVip": "EdrawMax Pro",
    "vipDesc": "Disfruta de más de 30 ventajas"
  },
  "pt": {
    "benefitText1": "Uso ilimitado de símbolos de desenho",
    "benefitText2": "Uso ilimitado de modelos de boutique",
    "benefitText3": "Exporte arquivos sem marcas d'água",
    "benefitText4": "10GB de armazenamento em nuvem",
    "vip": "Comprar agora",
    "showMore": "Saber mais",
    "edrawmaxVip": "EdrawMax Pro",
    "vipDesc": "Aproveite mais de 30 benefícios"
  },
  "it": {
    "benefitText1": "Uso illimitato di simboli per disegno",
    "benefitText2": "Uso illimitato di modelli boutique",
    "benefitText3": "Esporta file senza filigrane",
    "benefitText4": "10 GB di archiviazione su cloud",
    "vip": "Acquista ora",
    "showMore": "Ulteriori informazioni",
    "edrawmaxVip": "EdrawMax Pro",
    "vipDesc": "Usufruisci di oltre 30 vantaggi"
  },
  "tw": {
    "benefitText1": "無限使用繪圖符號",
    "benefitText2": "無限使用精品範本",
    "benefitText3": "匯出無浮水印的檔案",
    "benefitText4": "10GB 雲端儲存空間",
    "vip": "立即購買",
    "showMore": "深入瞭解",
    "edrawmaxVip": "EdrawMax Pro",
    "vipDesc": "享用超過 30 個權益"
  },
  "kr": {
    "benefitText1": "기호 그리기 무제한 사용",
    "benefitText2": "템플릿 부티크 무제한 사용",
    "benefitText3": "워터마크 없이 파일 내보내기",
    "benefitText4": "10GB 클라우드 스토리지",
    "vip": "지금 구매하기",
    "showMore": "자세히 알아보기",
    "edrawmaxVip": "EdrawMax Pro",
    "vipDesc": "30가지 이상의 혜택을 누리세요."
  }
}
</i18n>
